import FingerprintJS from '@fingerprintjs/fingerprintjs'
import type { GetResult } from '@fingerprintjs/fingerprintjs';

export default defineNuxtPlugin({
  name: 'cryptography', // important
  enforce: 'pre',
  setup() {
    const fpPromise = FingerprintJS.load()

    const fingerprintResult = async (): Promise<GetResult> => {
      const fp = await fpPromise
      return fp.get()
    }

    return {
      provide: {
        cryptography: {
          fingerprint: {
            deviceId: async () => {
                return fingerprintResult().then(result => result.visitorId);
            }
          }
        }
      },
    }
  },
  env: {
    islands: false
  }
})